export { Globals, handleAjaxError, ajaxDataRows, ajaxNumRows, getCookie, checkError, setCookie, displayAlert } ;

const Globals = (function()
{
    const APIFolder = '/api/v1.0';

    function Globals() {
    }

    Object.defineProperty(Globals, "APIFolder", {
        get: function() {
            return 'https://' + document.location.hostname + APIFolder;
        },
    });

    Object.defineProperty(Globals, "BaseURL", {
        get: function() {
            return 'https://' + document.location.hostname ;
        },
    });

    return Globals;
})();

export const getDataWithPromise = (url, type, data)  =>
{
    return new Promise((resolve, reject) =>
    {
        $.ajax(
            {
                type: type,
                url: url,
                data: data,
                success: (data) =>
                {
                    if (checkError(data))
                    {
                        resolve ( data );
                    }
                },
                error: (jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                }
            });
    });
}

export const getStatusFromResponse = ( response ) =>
{

}

export const getDataFromResponse = ( response ) =>
{
    return response.results.record_set ;
}

export const getNumRowsFromResponse = ( response ) =>
{
    return response.results.rows ;
}

export const UserTypes = {
    USER_TYPE_ADMIN : 4,
    USER_TYPE_CHILD : 2,
    USER_TYPE_TEACHER : 1,
    USER_TYPE_SCHOOL_ADMIN : 3,
    USER_TYPE_GOVERNOR: 25,
}

export const UserTypeNames = {
    USER_TYPE_NAME_ADMIN : 'admin',
}

const WORK_TYPE_NEW_CHILD = 1;
const KS1_ID = 2 ;
const KS2_ID = 3 ;
const KS3_ID = 4 ;
const KS4_ID = 5 ;
const KS5_ID = 6 ;
const KS6_ID = 7 ;


// *********************************************
// DISPLAY ERRORS - IN PROGRESS
//*********************************************

function setCookie(cname,cvalue,exdays)
{
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname)
{
    var name = cname + "=";

    var decodedCookie = decodeURIComponent(document.cookie);

    var ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++)
    {
        var c = ca[i];
        while (c.charAt(0) == ' ')
        {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0)
        {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

function ajaxNumRows ( data )
{
    return data.results.rows ;
}

function ajaxDataRows ( data )
{
    return data.results.record_set ;
}

function checkError( data )
{
    if ( data != null )
    {
        var status = data.results ;

        if ( status != null )
        {
            if ( status.error == 'OK' )
            {
                return true ;
            }
            else
            {
                if ( status.error == 'fail' )
                {
                    var displayMessage = "<p>Error: " +status.error + "</p>" ;
                    displayMessage += "<p>Message: " +status.errorDetail.message + "</p>" ;

                    if ( status.errorDetail.calling_function != null )
                    {
                        displayMessage += "<p>Calling Function: " +status.errorDetail.calling_function.class + "::" + status.errorDetail.calling_function.function + "()</p>" ;
                    }
                }
                else if ( data.result == "fail" )
                {
                    status = data.results ;

                    if ( data.Error == "PDO Exception")
                    {
                        var displayMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                        displayMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                        displayMessage += '<p>' + status.errorDetail.message + '</p>' ;
                    }
                    else if ( data.Error == "Exception")
                    {
                        var displayMessage = "<p>Error File: " + status.errorDetail.file + '</p>';
                        displayMessage += "<p>Error Line: " + status.errorDetail.line + '</p>' ;
                        displayMessage += '<p>' + status.errorDetail.message + '</p>' ;
                    }
                    else
                    {
                        var displayMessage = "<p>Error: " +status.error + "</p>" ;
                        displayMessage += "<p>Detail: " +status.errorDetail + "</p>" ;
                    }
                }
                else
                {
                    var displayMessage = "<p>Error: " +status.error + "</p>" ;
                    displayMessage += "<p>Detail: " +status.errorDetail + "</p>" ;

                }

                bootbox.alert({
                    size: "large",
                    title: "The operation failed",
                    message: displayMessage,
                    callback: function()
                    {
                    }
                })
            }
        }
        else
        {
            bootbox.alert({
                size: "large",
                title: "The operation failed",
                message: data,
                callback: function()
                {
                }
            })
        }
    }
    else
    {
        bootbox.alert({
            size: "large",
            title: "The operation failed",
            message: "Null Response from server",
            callback: function()
            {
            }
        })
    }

    return false ;
}

function displayAlert ( params )
{
    let title = 'Alert' ;
    let displayMessage = "EMPTY MESSAGE" ;

    if ( params.title != null )
    {
        title = params.title ;
    }

    if ( params.message != null )
    {
        displayMessage = params.message ;
    }

    bootbox.alert({
        size: "large",
        title: title,
        message: displayMessage,
        callback: function()
        {
        }
    })
}

function getErrorObject()
{
    try
    {
        throw Error('')
    }
    catch(err)
    {
        return err;
    }
}

function handleAjaxError(jqXHR, exception, error, returnUrl)
{
    let msg = '' ;
    let fullMessage = '' ;

    if ( jqXHR.constructor === TypeError )
    {
        console.log ( jqXHR ) ;
        msg = "Type Error" ;
        fullMessage = jqXHR.message + '<br><br>' + jqXHR.fileName + "<br><br>" + jqXHR.lineNumber + "<br><br>" + jqXHR.stack ;
    }
    else
    {
        if ( jqXHR.status === 0 || jqXHR.readyState === 0)
        {
            return;
        } ;

        if (jqXHR.status === 0) {
            msg = 'Not connect.\n Verify Network.';
        } else if (jqXHR.status == 404) {
            msg = 'Requested page not found. [404]';
        } else if (jqXHR.status == 400) {
            msg = 'Bad Parameters. [400]';
        } else if (jqXHR.status == 401) {
            msg = 'Not Authorised. [404]';
        } else if (jqXHR.status == 500) {
            msg = 'Internal Server Error [500].';
        } else if (exception === 'parsererror') {
            msg = 'Requested JSON parse failed.';
        } else if (exception === 'timeout') {
            msg = 'Time out error.';
        } else if (exception === 'abort') {
            msg = 'Ajax request aborted.';
        } else {
            msg = 'Uncaught Error.\n' + jqXHR.responseText;
        }

        fullMessage = error.stack + jqXHR.responseText + '<br><br>' + getErrorObject().stack ;

        if ( jqXHR.status == 401 )
        {
            fullMessage = "You are not authorised to perform this operation."
        }
    }

    bootbox.alert({
        size: "large",
        title: "The operation failed " + msg,
        message: fullMessage,
        callback: function()
        {
            if ( returnUrl != null )
            {
                location.assign(returnUrl);
            }
        }
    })

}

/*globals jQuery, window */
(function($) {
    $.retryAjax = function (ajaxParams) {
        var errorCallback;
        ajaxParams.tryCount = (!ajaxParams.tryCount) ? 0 : ajaxParams.tryCount;
        ajaxParams.retryLimit = (!ajaxParams.retryLimit) ? 2 : ajaxParams.retryLimit;
        ajaxParams.suppressErrors = true;

        if (ajaxParams.error) {
            errorCallback = ajaxParams.error;
            delete ajaxParams.error;
        } else {
            errorCallback = function () {

            };
        }

        ajaxParams.complete = function (jqXHR, textStatus) {
            if ($.inArray(textStatus, ['timeout', 'abort', 'error']) > -1) {
                this.tryCount++;
                if (this.tryCount <= this.retryLimit) {

                    // fire error handling on the last try
                    if (this.tryCount === this.retryLimit) {
                        this.error = errorCallback;
                        delete this.suppressErrors;
                    }

                    //try again
                    $.ajax(this);
                    return true;
                }

                window.alert('There was a server error.  Please refresh the page.  If the issue persists, give us a call. Thanks!');
                return true;
            }
        };

        $.ajax(ajaxParams);
    };
}(jQuery));

(function($) {

    $.originalAjax = $.ajax ;

    $.ajax = function (ajaxParams) {

        ajaxParams.loggingIn = false;

        let oldError = ajaxParams.error;

        ajaxParams.error = function (jqXHR, textStatus, error)
        {
            if ( errorOccurredBecauseAuthenticationRequired( this, jqXHR, textStatus, error ) )
            {
                // if we're handling an authentication error, it probably means the user has a session timeout
                // so we need to ask them to re-authenticate
                //
                // Once the user has logged in again, we can continue the request using the original parameters

                ajaxParams.loggingIn = true ;

                tryAgain ( this, textStatus, jqXHR );
            }
            else
            {
                // Just pass the result on to the original Success handler
                if ( oldError != null )
                {
                    oldError(jqXHR, textStatus, error);
                }
            }
        };

        $.originalAjax(ajaxParams);
    };
}(jQuery));

function errorOccurredBecauseAuthenticationRequired ( response, jqXHR, textStatus, error )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        let data = jqXHR.responseJSON ;

        if ( data != null && data.result != null && data.result == "fail" && data.error != null && data.error == "Authentication Fail" )
        {
            res = true ;
        }
    }

    return res ;
}

function functionFailedBecauseAuthenticationRequired ( response, data )
{
    let res = false ;

    if ( response.loggingIn == true )
    {
        // This is a successful route
        res = false ;
    }
    else
    {
        if ( data != null && data.result != null && data.result == "fail" && data.error != null && data.error == "Authentication Fail" )
        {
            res = true ;
        }
    }

    return res ;
}

function doLogin( response, textStatus, jqXHR, username, password, establishment )
{
    // Globals are defined in the globals.js class
    var root = Globals.APIFolder ;

    var service = "/login" ;

    $.ajax({
        type: 'POST',
        url: root + service,
        data: { inpUsername: username, inpPassword: password, inpEstablishmentNumber: establishment  },
        beforeSend:function()
        {
            // this is where we append a loading image
        },
        success:(data)=>
        {
            if ( data.status.result == 'success')
            {
                $.originalAjax ( response ) ;
            }
            else
            {
                tryAgain ( response, textStatus, jqXHR) ;
            }
        },
        error:(jqXHR, textStatus, error)=>
        {
            handleAjaxError ( jqXHR, textStatus, error) ;
        }
    });
}

function loginFormElements ()
{
    var string = "<div>" ;

    string+= '<h2>Session Timed Out</h2>' ;

    string+= '<p>Your session has timed out.</p>' ;

    string+= '<p>Please re-enter your login credentials to continue</p>' ;

    string += "<form class='form' role='form'>" ;
    string += '<div class="form-group">' ;
    string += '<label for="inputEstablishment">Establishment Number</label>' ;
    string += '<input type="text" class="form-control" id="inputEstablishment" name="inputEstablishment" placeholder="Establishment NUmber">' ;
    string += '</div> ' ;
    string += '<div class="form-group">' ;
    string += '<label for="inputUserName">User Name</label>' ;
    string += '<input type="text" class="form-control" id="inputUserName" name="inputUserName" placeholder="User Name">' ;
    string += '</div> ' ;
    string += '<div class="form-group"> ';
    string += '<label for="inputPassword">Password</label>' ;
    string += '<input type="password" class="form-control" id="inputPassword" name="inputPassword" placeholder="Password"> ' ;
    string += '</div>';
    string += "</form>" ;
    string += "<div>" ;

    return string ;
}

function tryAgain ( response, textStatus, jqXHR)
{
    var form = loginFormElements () ;

    var modal = bootbox.dialog({
        message: form,
        title: "",
        buttons: [
            {
                label: "Login",
                className: "btn btn-primary pull-right",
                callback: function() {

                    var inputUserName = $('div.bootbox-body form.form div.form-group input#inputUserName');
                    var userName = inputUserName[0].value;

                    var inputUserPassword = $('div.bootbox-body form.form div.form-group input#inputPassword');
                    var userPassword = inputUserPassword[0].value;

                    var inputEstablishment = $('div.bootbox-body form.form div.form-group input#inputEstablishment');
                    var establishment = inputEstablishment[0].value;

                    doLogin ( response, textStatus, jqXHR, userName, userPassword, establishment) ;

                    return true;
                }
            }
        ],
        show: false,
        onEscape: function() {
            modal.modal("hide");
        }
    });

    modal.modal("show");
}


function showSpinner()
{
    $('#spin-container').show();
    $('#spin-wrapper').show();
}

function hideSpinner()
{
    $('#spin-container').hide();
    $('#spin-wrapper').hide();
}
